import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

// Calls the backend Cloud Function to create a Stripe Connect onboarding link
export const createStripeConnectLink = async (returnUrl) => {
  const createLink = httpsCallable(functions, 'createStripeConnectLink');
  const result = await createLink({ returnUrl });
  return result.data.url;
}; 

// Create Stripe Connect dashboard link
export const createStripeConnectDashboardLink = async (returnUrl) => {
  try {
    const createDashboard = httpsCallable(functions, 'createStripeConnectDashboard');
    const result = await createDashboard({ returnUrl });
    return result.data.url;
  } catch (error) {
    console.error('Error creating dashboard link:', error);
    throw new Error(error.message || 'Failed to create dashboard link');
  }
};